// extracted by mini-css-extract-plugin
module.exports = {"three-w-details":"styles_three-w-details__2ono2","threeWDetails":"styles_three-w-details__2ono2"};